import history from '@emico/history'
import { globalWindow } from '@emico/ssr-utils'

import { AuthPage, AuthPageContextProps } from './ApolloConnector'

const getPageByPathname = (pathname: string, page: AuthPage) => {
  if (typeof page === 'string') {
    return page
  }

  const match = Object.keys(page).find((path) => pathname.startsWith(path))
  return match ? page[match] : page.default
}

export const redirectToLogin = (authPages: AuthPageContextProps) => {
  const currentPath = globalWindow?.location.pathname

  if (!currentPath) {
    return {
      shouldRedirect: false,
      redirect: undefined,
    }
  }

  const loginPage = getPageByPathname(currentPath, authPages.login)
  const logoutPage = getPageByPathname(currentPath, authPages.logout)
  const shouldRedirect = currentPath !== loginPage

  const redirect = () => {
    history?.push(loginPage, {
      // If a GraphQL error occurred during logout, this could be triggered and
      // cause the user to get into an endless login-logout cycle.
      cameFrom: currentPath === logoutPage ? undefined : currentPath,
    })
  }

  return {
    shouldRedirect,
    redirect,
  }
}
